import { useMemo } from "react";

import { isOptionArray, Option } from "api/common/types/common.types";

// Utility to turn an array of strings into an array of options
const createOptionsFromStrings = (strings: string[]): Option[] => {
  return strings.map((s) => ({
    value: s,
    label: s,
  }));
};

export const useNormalizedOptions = (options: string[] | Option[]) => {
  const normalizedOptions = useMemo(() => {
    return isOptionArray(options) ? options : createOptionsFromStrings(options);
  }, [options]);

  return normalizedOptions;
};
